<template>
  <v-data-table
    dense
    hide-default-footer
    fixed-header
    disable-sort
    calculate-widths
    :items-per-page="page_sizes[pageSizeIndex]"
    :headers="headers"
    :items="items"
    height="35vh"
    :no-data-text="generateMessage('requests.logs.noItems')"
    :loading="isLoadingItems"
    class="elevation-1 secondarybackground striped-table"
  >
    <template v-slot:top>
      <div class="d-flex justify-end">
        <custom-btn-icon
          v-if="items.length > 0"
          :loading="isDownloading"
          color="success"
          icon="mdi-file-excel"
          tooltip-text="Export Excel"
          @click="handleExcelExportClick"
        />
        <custom-page-selector namespace="requests/logs" />
      </div>
    </template>
    <template v-slot:item.description="{ item }">
      <div class="caption">
        {{ item.datetime | showDate }}
        <div v-if="item.application_fullname">
          Créé par
          <span class="primary--text">{{ item.application_fullname }}</span>
        </div>
        <div class="font-weight-bold">
          {{ item.description }}
        </div>
      </div>
    </template>
    <template v-slot:item.recipient="{ item }">
      <div class="primary--text" v-if="item.recipient_lastname">
        {{ item.recipient_firstname + ' ' + item.recipient_lastname }}
      </div>
      <div class="d-flex" v-if="item.recipient_employee_id">
        <v-icon>person</v-icon>
        <copy-to-clipboard :message="item.recipient_employee_id" />
      </div>
      <div class="d-flex" v-if="item.phone_number">
        <v-icon>phone</v-icon>
        <copy-to-clipboard :message="item.phone_number" />
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { generateMessage } from '@/utils/i18n';
import { PAGE_SIZES } from '@/store/baseModule/constants';
import { createNamespacedHelpers } from 'vuex';
import CustomPageSelector from '@/components/selects/customPageSelector/index';
import CopyToClipboard from '@/components/tools/CopyToClipboard';
import CustomBtnIcon from '@/components/displays/CustomBtnIcon';
import ExportExcelAPI from '@/services/api/internal/exportExcelAPI';

const { mapGetters } = createNamespacedHelpers('requests/logs');

export default {
  name: 'RequestLogsTable',
  components: {
    CustomBtnIcon,
    CopyToClipboard,
    CustomPageSelector,
  },
  computed: {
    ...mapGetters(['items', 'isLoadingItems', 'pageSizeIndex', 'urlParamId']),
  },
  filters: {
    showDate(date) {
      return date.toLocaleString();
    },
  },
  data() {
    return {
      isDownloading: false,
      page_sizes: PAGE_SIZES,
      headers: [
        {
          text: this.generateMessage('requests.logs.fields.description'),
          value: 'description',
        },
        {
          text: this.generateMessage('requests.logs.fields.origin_name'),
          value: 'origin_name',
        },
        {
          text: this.generateMessage('requests.logs.fields.recipient'),
          value: 'recipient',
        },
        {
          text: this.generateMessage(
            'requests.logs.fields.recipient_exchange_type_name'
          ),
          value: 'recipient_exchange_type_name',
        },
        {
          text: this.generateMessage('requests.logs.fields.comments'),
          value: 'comments',
        },
      ].map((item) => {
        return { ...item, class: 'secondarybackground' };
      }),
    };
  },
  methods: {
    generateMessage,
    handleExcelExportClick() {
      this.isDownloading = true;
      ExportExcelAPI.getItems(
        {
          url: `p2c/api/v1/requests/${this.urlParamId}/logs`,
        },
        `actions-${this.urlParamId}`
      ).finally(() => {
        this.isDownloading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';
</style>
